export const getGlobalError = state => {
    return state.globalError
}
